import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useAppSelector } from '../../app/hooks';
import Spinner from '../../components/common/Spinner';

export const Finup = () => {
  const history = useHistory();

  const { user } = useAppSelector((state) => state.auth.userInfo);

  const redirectToFinup = () =>
    (window.location.href = `${process.env.REACT_APP_FINUP_URL}?userId=${user.id}`);

  useEffect(() => {
    if (user) {
      redirectToFinup();
    } else {
      history.push('/login?finup=true');
    }
  }, []);

  return <Spinner fullScreen={true} />;
};
